import { Component } from '@angular/core';
import { RidButton } from '../../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-categorise-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './categorise-page.html',
})
export class CategorisePage {}
